let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jHv5H")).then(() => parcelRequire('8pclD'));